__turbopack_context__.v({
  "root": "ExitApp-module-scss-module__1qpbmG__root",
  "root_title": "ExitApp-module-scss-module__1qpbmG__root_title",
});
